<template>
<div class="GateWayFail">
    <div>
        <div class="column items-center">
             <div class="col" >
                <q-btn size="35px" round  color="red" icon="far fa-times-circle"   />
            </div> 
            <div class="col text-h4 text-weight-medium header" >
                Request Submitted Failed
            </div>
            <div class="col text-h4 text-weight-medium header" >
                {{TC_Reason}}
            </div>
        </div>
    </div>
</div>
</template>
<script>

export default {
    name : 'GateWayFail',
    components : { },
    data() {
        return { }
    },
    props: {
        TC_Reason:String,
        image_url:String,
    }, 
    mounted(){ },
    computed: {},
    methods: { }
}
</script>
<style>
.header{
    color: #59599e;
}
</style>